import { useTelegramUser, useTelegramInitData, useTelegramTheme } from '../utils/telegram';

/**
 * Custom hook for Telegram WebApp functionality
 * This hook combines multiple TMA hooks for convenience
 */
export function useTelegram() {
  const user = useTelegramUser();
  const initDataRaw = useTelegramInitData();
  const theme = useTelegramTheme();

  return {
    user,
    initData: initDataRaw || '',
    initDataRaw: initDataRaw || '',  // Return raw string for WebSocket auth
    theme
  };
}
